import React, { PureComponent } from 'react';
import { PropTypes as RPT } from 'prop-types';
import Link from './Link.react';

export const BUTTON_KIND_PRIMARY = 'primary';
export const BUTTON_KIND_SECONDARY = 'secondary';
export const BUTTON_KIND_GHOST_LIGHT = 'ghost_light';
export const BUTTON_KIND_GHOST_DARK = 'ghost_dark';
export const BUTTON_SIZE_NORMAL = 'normal';
export const BUTTON_SIZE_LARGE = 'large';

export default class Button extends PureComponent {
  static propTypes = {
    children: RPT.node,
    disabled: RPT.bool,
    className: RPT.string,
    id: RPT.string,
    link: RPT.string,
    loading: RPT.bool,
    loadingText: RPT.string,
    onSubmit: RPT.func,
    type: RPT.string,
  }

  static defaultProps = {
    kind: BUTTON_KIND_PRIMARY,
    size: BUTTON_SIZE_NORMAL,
    type: null,
  }

  render() {
    const {
      children,
      disabled,
      className,
      link,
      id,
      loading,
      loadingText,
      type,
      onSubmit,
    } = this.props;

    const disabledState = disabled || loading;

    const content = (loading && loadingText) ? loadingText : children;

    if (link) {
      return (
        <Link className={className} disabled={disabledState} id={id} to={link} key="button">
          {content}
        </Link>
      );
    }

    return (
      <button className={className} id={id} disabled={disabledState} key="button" type={type} onSubmit={onSubmit}>
        {content}
      </button>
    );
  }
}
